function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2962 6.39136H22.5454V3.5759H23.2962C23.6849 3.5759 24 3.26076 24 2.87203C24 2.48329 23.6849 2.16815 23.2962 2.16815H5.65725C4.1048 2.16815 2.8418 3.43115 2.8418 4.98361C2.8418 6.53606 4.1048 7.79906 5.65725 7.79906H6.3623V5.68996C6.3623 5.30123 6.67744 4.98609 7.06617 4.98609H11.273C11.6617 4.98609 11.9768 5.30123 11.9768 5.68996V7.79906C12.7167 7.79943 22.1675 7.80736 23.2962 7.79906C23.6849 7.79906 24 7.48392 24 7.09518C24 6.7065 23.6849 6.39136 23.2962 6.39136Z",
  fill: "#9298A8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5686 8.5547V6.39381H7.76953V8.54158C8.21442 8.28335 8.52038 7.89775 9.15375 7.89775C9.78352 7.89775 10.087 8.2781 10.5686 8.5547Z",
  fill: "#9298A8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2962 17.6088C23.6849 17.6088 24 17.2937 24 16.905C24 16.5162 23.6849 16.2011 23.2962 16.2011C22.1103 16.2011 18.7995 16.2011 17.6124 16.2011V16.9519C17.6124 17.5099 16.9896 17.8497 16.5199 17.5388L14.7899 16.393L13.0952 17.5355C12.6321 17.8478 11.9979 17.5181 11.9979 16.9519V16.2011H5.65725C4.1048 16.2011 2.8418 17.4641 2.8418 19.0165C2.8418 20.569 4.1048 21.832 5.65725 21.832H23.2962C23.6849 21.832 24 21.5168 24 21.1281C24 20.7394 23.6849 20.4242 23.2962 20.4242H22.5454V17.6088H23.2962V17.6088Z",
  fill: "#9298A8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9979 12.6887C11.9979 12.3 12.313 11.9849 12.7018 11.9849H16.9086C17.2973 11.9849 17.6124 12.3 17.6124 12.6887V14.7933H18.3428C19.8953 14.7933 21.1583 13.5303 21.1583 11.9778C21.1583 10.4254 19.8953 9.16237 18.3428 9.16237H11.9768V9.86624C11.9768 10.4263 11.3516 10.763 10.8838 10.4528L9.15422 9.30548L7.46002 10.4496C6.9968 10.7624 6.36225 10.4323 6.36225 9.86624V9.16237H0.703875C0.315141 9.16237 0 9.47751 0 9.86624C0 10.255 0.315141 10.5701 0.703875 10.5701H1.45467V13.3856H0.703875C0.315141 13.3856 0 13.7007 0 14.0894C0 14.4782 0.315141 14.7933 0.703875 14.7933C0.878812 14.7933 9.10758 14.7942 11.9979 14.7933V12.6887Z",
  fill: "#9298A8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.7905 14.9852C15.42 14.9852 15.7234 15.365 16.2053 15.6415V13.3926H13.4062V15.6284C13.8529 15.3695 14.1577 14.9852 14.7905 14.9852Z",
  fill: "#9298A8"
});

var SvgBundle = function SvgBundle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBundle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bundle.866903d8.svg";
export { ForwardRef as ReactComponent };